//* 布局属性
import type { ModulesNavigation } from "@/views/details/components/container/src";
//* 组件
import type ModuleComponent1 from "./components/module1/index.vue";
import type ModuleComponent2 from "./components/module2/index.vue";
import type ModuleComponent3 from "./components/module3/index.vue";
import type ModuleComponent4 from "./components/module4/index.vue";
import type ModuleComponent5 from "./components/module5/index.vue";
import type ModuleComponent6 from "./components/module6/index.vue";

//* 样式
import css_father from "../../components/container/style/index.module.less";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    //* 节点
    const nodes = {
        module1: ref<InstanceType<typeof ModuleComponent1>>(),
        module2: ref<InstanceType<typeof ModuleComponent2>>(),
        module3: ref<InstanceType<typeof ModuleComponent3>>(),
        module4: ref<InstanceType<typeof ModuleComponent4>>(),
        module5: ref<InstanceType<typeof ModuleComponent5>>(),
        module6: ref<InstanceType<typeof ModuleComponent6>>(),
    };

    //* 响应式变量
    const refs = {
        navigations: ref<ModulesNavigation[]>([
            { index: 1, name: i18n.t("BasicInformation"), ref: nodes.module1, visible: true },
            { index: 2, name: i18n.t("DiseaseCharacterization"), ref: nodes.module2, visible: true },
            { index: 3, name: i18n.t("GenesMutations"), ref: nodes.module3, visible: true },
            { index: 4, name: i18n.t("TargetDrug"), ref: nodes.module4, visible: true },
            { index: 5, name: i18n.t("DiseaseModel"), ref: nodes.module5, visible: true },
            { index: 6, name: i18n.t("References"), ref: nodes.module6, visible: true },
        ]),
    };

    //* 函数列表
    const methods = {
        register: (href: string, module: any, method: "POST" | "GET" = "GET") => {
            return api.frontend(href, {
                method: method,
                data: { id: route.params.id, mode: "disease" },
                error: () => module?.hidden(),
                hidden: true,
                success: (response) => {
                    if (!response) module?.hidden();
                    else {
                        module?.render(response);
                    }
                },
            });
        },
        move: (node: any) => {
            if (node && node.$el) {
                const node_container = document.querySelector(`.${css_father["header-container"]}`) as HTMLDivElement;
                const node_name_zh = document.querySelector(`.${css_father["name_zh"]}`) as HTMLDivElement | null;
                const offset = node_container.offsetHeight - (node_name_zh ? node_name_zh.offsetHeight : 0);
                scrollTo({
                    top: node.$el.offsetTop - offset,
                    behavior: "smooth",
                });
            }
        },
    };

    //* 计算属性
    const computeds = {
        options: computed(() => {
            return {
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/307d5b6f-f9a4-4268-a9ca-54fc1a446656.webp",
                navigations: refs.navigations.value,
            };
        }),
    };

    return { refs, nodes, methods, computeds };
};
